/**
 * The one dark recess the consent screens (and the coach's strip above its composer) put under text that
 * would otherwise sit straight on the page gradient.
 *
 * The page's warm gradient has a tan peak at 54% of its height (`#8c6653`, `DESIGN.md`), and cream cannot
 * reach 4.5:1 against the bare stop: full cream is 4.35:1 there at best. These surfaces came before the canvas
 * had its contrast scrim, so a surface that carries a sentence the person must be able to read brings its own
 * ground. Which of them still need one under the scrim is #682's question. This is it: 26,20,19 at 0.6, the ground `WriteFailureNote` first used for the line
 * that says nothing was recorded. `consentGrounds.test.ts` grades it, with the text it carries, against that
 * peak, so a change to the amount fails there and not in a browser.
 */
export const RECESS = 'rgba(26, 20, 19, 0.6)'

/**
 * The ground of the analytics ask's band and dialogs (AA-D2 to AA-D8; the artboards `Main`, `Ask-dialog-web`,
 * `Conflict-dialog-web`, `Withdraw-web`): opaque, so their text never depends on the page gradient behind them.
 * Cream on it is 14.6:1, the 90% sentences 12.0:1 and the 72% footnotes 8.1:1 (computed from the hex values in the
 * decisions file's *Quality*), the figures `consentGrounds.test.ts` holds.
 */
export const BAND_GROUND = '#201c1a'

/** The artboards' sentences: 90% cream (12.0:1 on `BAND_GROUND`), and the 82% of a second paragraph under them. */
export const SENTENCE = 'color-mix(in oklab, var(--text-cream) 90%, transparent)'
export const SENTENCE_QUIET = 'color-mix(in oklab, var(--text-cream) 82%, transparent)'
